import React from "react";
import {IconType} from "react-icons";

import {FormLabelTypography} from "@/components/form/FormLabel.tsx";
import {FormSubtextSupportLinkPosition} from "@/components/formSubtext/FormSubtext.tsx";

// Rename tooltip -> helpText
// Rename helpText -> subText
export interface FieldProps {
  id?: string;
  name: string;
  label?: React.ReactNode;
  className?: string;
  required?: boolean;
  hasRequiredLabel?: boolean;
  tooltip?: string;
  helpText?: string;
  supportLink?: string;
  supportLinkText?: string;
  supportLinkPosition?: FormSubtextSupportLinkPosition;
  disabled?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
  labelIcon?: IconType;
  labelTypography?: FormLabelTypography;
  formSubtextClassName?: string;
  dataTestId?: string;
  invalid?: boolean;
}

export enum FieldType {
  Text = "text",
  Percentage = "percentage",
  Password = "password",
  Select = "select",
  Version = "version",
  TextArea = "textarea",
  DNSAutoload = "dns-autoload",
  WHOISAutoload = "whois-autoload",
  RDAPAutoload = "rdap-autoload",
  CheckBox = "checkbox",
  Radio = "radio",
  Tags = "tags",
  MultiCheckSelector = "multi-check-selector",
  SingleCheckSelector = "single-check-selector",
  Array = "array",
}
